import './PieChart.scss';

import { ResponsivePie } from '@nivo/pie';
import { Radio } from 'antd';
import type { Codebook } from 'common/models';
import { CustomEmpty } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useState } from 'react';

import type { DashboardData } from '../models';
import { prepareData } from './pieChartHelpers';

interface OwnProps {
  data: DashboardData;
  orderCategories: Codebook[];
}

type SelectedType = 'state' | 'category';
type SelectedPeriod = 'month' | 'year';

const PieChart = (props: OwnProps) => {
  const { t } = useCustomTranslation();
  const [selectedType, setSelectedType] = useState<SelectedType>('state');
  const [selectedPeriod, setSelectedPeriod] = useState<SelectedPeriod>('month');

  const data = prepareData(
    props.data.orderInterventions,
    t,
    selectedType,
    selectedPeriod,
    props.orderCategories
  );

  const noData = data.length === 0;

  return (
    <div className="PieChart">
      <div className="PieChart_controls">
        <Radio.Group
          defaultValue={selectedType}
          onChange={(e) => {
            setSelectedType(e.target.value);
          }}
        >
          <Radio.Button value="state">{t('dashboard:pieChart_filter_state')}</Radio.Button>
          <Radio.Button value="category">{t('dashboard:pieChart_filter_category')}</Radio.Button>
        </Radio.Group>
        <Radio.Group
          defaultValue={selectedPeriod}
          onChange={(e) => {
            setSelectedPeriod(e.target.value);
          }}
        >
          <Radio.Button value="month">{t('dashboard:pieChart_filter_month')}</Radio.Button>
          <Radio.Button value="year">{t('dashboard:pieChart_filter_year')}</Radio.Button>
        </Radio.Group>
      </div>
      <div className="PieChart_chart-container">
        {noData ? (
          <CustomEmpty />
        ) : (
          <ResponsivePie
            data={data}
            innerRadius={0.5}
            padAngle={1}
            cornerRadius={3}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
            enableArcLinkLabels={false}
            isInteractive
            activeOuterRadiusOffset={10}
            margin={{ top: 20, left: 20, right: 130, bottom: 20 }}
            legends={[
              {
                anchor: 'right',
                direction: 'column',
                translateX: 130,
                translateY: 0,
                itemWidth: 110,
                itemHeight: 24,
                itemTextColor: '#333333',
                symbolSize: 16,
                symbolShape: 'circle'
              }
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default PieChart;
